import { ServiceFetch } from '../service-fetch'

export default class RedeemGiftListModel extends ServiceFetch {
    getRedeemGiftListBy = (data) => this.authFetch({
        url: 'redeem-gift-list/getRedeemGiftListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}
